<template>
  <div id="ResultNav">
    <div class="list1">
      1.&nbsp;财务管理与资本运作
      <ul>
        <li v-for="(item,index) in list1" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      2.&nbsp;节能减排与社会责任管理
      <ul>
        <li v-for="(item,index) in list2" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      3.&nbsp;科技创新与知识产权管理
      <ul>
        <li v-for="(item,index) in list1" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      4.&nbsp;企业文化建设
      <ul>
        <li v-for="(item,index) in list2" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      5.&nbsp;全面风险管理与内部控制
      <ul>
        <li v-for="(item,index) in list1" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      6.&nbsp;人力资源及薪酬考核
      <ul>
        <li v-for="(item,index) in list2" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      7.&nbsp;生产运作与精益管理
      <ul>
        <li v-for="(item,index) in list1" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      8.&nbsp;市场营销与国际化运营
      <ul>
        <li v-for="(item,index) in list2" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      9.&nbsp;现代物流与价值链管理
      <ul>
        <li v-for="(item,index) in list1" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      10.&nbsp;信息化与互联网建设
      <ul>
        <li v-for="(item,index) in list2" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      11.&nbsp;战略与模式管理
      <ul>
        <li v-for="(item,index) in list1" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
      12.&nbsp;组织与制度
      <ul>
        <li v-for="(item,index) in list2" :key="index" :title="item">
          <div>{{item}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "ResultNav",
  data() {
    return {
      list1: [
        "现代企业“大财务”管理平台创新建立与实践",
        "人力资源会计在施工企业中的应用及研究",
        "精益成本管理在膏体充填开采中的研究与应用",
        "EVA诊断模型研究与实践",
        "防控区域施工项目运营风险的财务管理创新与实践",
        "基于托管运营为核心的轻资产管理实践",
        "建筑企业实施项目成本标准化管控的探索与实践",
        "煤炭企业控制工程施工成本有效途径的探索与实践",
        "煤炭施工企业项目成本精细化管理的探索与实践",
        "煤炭铁路运销企业资金链良性循环管理",
        "铁路运销企业内部市场化运行方案及结算研究",
        "细化施工企业财务预算管理的研究与应用",
        "以托管运营为核心的选煤厂轻资产管理"
      ],
      list2: [
        "构建企业依托政府资源的涉法涉诉信访工作体系",
        "“363”沟通机制的建立与实践",
        "煤矿安全诚信管理研究与实践",
        "创建国家安全标准化一级水泥的企业探索与实践",
        "建筑施工企业履行社会责任的探讨与实践",
        "基于内循环、零排放的水资源治理为核心的生态环保矿山实践",
        "构建水泥企业环保节能体系的探索与实践"
      ],
      list3: [
        "条带煤柱复采安全技术对策",
        "采煤塌陷区复垦管理创新与实践",
        "安全时空分析与轨迹变换管控技术提升与应用",
        "集团公司技术创新考核体系",
        "快速高效开展膏体充填项目的探索与研究",
        "实施技术创新打造绿色矿山",
        "水泥企业自动化生产管理系统的创新与实践"
      ],
      list4: [
        "危机文化建设的探索与实践",
        "国企党建思想政治工作内部市场化运作的探索与实践",
        "岱庄煤矿基于多元成本文化建设的探索与实践",
        "矿井建设流动项目部“家文化”的建设与系统推进",
        "推行“微型党课”教育提升党员素质",
        "淄矿集团党委加强作风建设密切联系职工的创新与实践"
      ],
      list5: [
        "全面风险管理在企业经济运行中的探索和应用",
        "煤矿工程造价控制审核的探索与研究",
        "外委工程成本管理的探索与实践",
        "构建惩治和预防腐败体系建设的研究与实践",
        "廉洁风险防控管理体系在煤炭企业的研究与实践",
        "管理创新成果全面风险管控体系的创建与实施",
        "多元策略应对建筑施工企业风险",
        "全面风险管理体系研究设计与实施",
        "全面风险管理在基本建设企业的应用",
        "水泥企业并购中的法律风险防控与实践",
        "水泥企业法律风险防控的探索与实践"
      ],
      list6: [
        "创新考核分配机制探索实施管理岗位“人单酬”管理",
        "内部人才市场在建筑施工企业中的应用与实践",
        "员工帮助计划在企业思想政治工作中的创新与应用",
        "煤炭施工企业“精用工”管控的实践与应用",
        "专业人员继续教育培训学分制考核体系的创建及应用",
        "“塔”式技能人才体系  力促轻型矿井建设",
        "基于五项机制的职工队伍建设的研究与实践",
        "倾力锻造“双百人才” 助力企业科学发展的探索与实践",
        "淄矿集团建立人才多序列职业发展机制的探索与实践",
        "淄矿集团专业技术岗位发展通道的设立与应用",
        "国有企业补充医疗保险体系的建立与实施",
        "煤炭铁路专运用线基于关键绩效指标（KPI）考核的绩效管理",
        "煤炭施工企业职工队伍素质提升的探索及实践",
        "水泥企业岗位绩效考核分配体系与内部市场化融合的创新实践",
        "四位一体绩效管理考核体系的构建",
        "以全员绩效量化考核推动新建矿井转型发展的研究与实践",
        "运用“精用工”管理机制打造精优团队",
        "职工技能提升上岗准入机制的创新与实践"
      ],
      list7: [
        "煤矿安全事故风险动态管控",
        "以“设备包机制”为导向的生产线管理",
        "积极探索煤场管理新方法为企业生产经营保驾护航",
        "煤矿安全教育培训教材的编制与应用",
        "企业内部市场化管理的创新与应用",
        "提案改善在精益管理工作中的突出作用",
        "中小发电企业利用热电联产之路开创经济发展新亮点",
        "材料复用精细化创新管理",
        "高效集约生产，辅助专业化管理研究与应用",
        "基于内部市场化班组对标管理体系构建与实施",
        "建筑施工企业优化现场管理的探索与实践",
        "煤矿辅助生产专业化的探索与实施",
        "煤矿专用铁路转型发展与升级管理",
        "煤质防控管理体系的探索与实践",
        "内涵深化创新提升后勤管理服务水平",
        "三比三看三对照煤矿企业中的实践与应用",
        "煤矿企业三四级市场的探索与实践",
        "推行废旧物料管理实现节本降耗增效",
        "项目标准化管理在煤炭施工企业的实施",
        "新型干法水泥企业测量体系运行实践"
      ],
      list8: [
        "“提煤质、降单耗、保煤价”研究与实施",
        "基于煤炭产品结构调整的营销模式创新",
        "煤炭企业营销模式创新在应对煤炭危机中的探索与实践"
      ],
      list9: [
        "“三三二二”物资招标体系的构建与实施",
        "新动能主导煤炭物流企业转型发展的探索与实践"
      ],
      list10: [
        "以提高吨煤创效能力为目标的产品优化战略研究",
        "煤炭企业全面市场化改革的探索与实践",
        "管理创新成果混合所有制改制激发企业活力",
        "技术/销售绑定式的科技大营销管理模式",
        "外部对标管理体系在煤炭企业治亏创效中的研究与应用",
        "基于内部市场化创新型矿井建设的探索与实践",
        "经济形势逆变保持稳定健康发展的实践",
        "矿区铁路运营模式转型的探索与实践",
        "煤炭基本建设企业创新产业发展模式的探索与实践",
        "煤炭企业提高经济运行质量的探索与实践",
        "煤炭企业推行内部市场化管理模式的探索与实践",
        "煤炭施工企业专业化管理模式创新与应用",
        "市场下行形势下煤炭建设项目再评价研究与实施",
        "以增值增效为目标的产品结构调整战略研究",
        "资源型企业发展结构性生产力的探索与实践",
        "资源型企业基于审慎原则的多元化投资战略"
      ],
      list11: [
        "“3+1”模式提升服务职工群众能力",
        "“五全十制”内部市场化管理在经济逆势中的突出作用",
        "岗位练兵长效机制实施",
        "驻矿督导安全管理模式的应用",
        "水泥公司二级单位“事业部制”改革的探索与实践",
        "水泥公司推行“大后勤”管理模式的创新与实践",
        "推行完全市场化项目部运作模式的探索与实践",
        "许 厂 煤 矿“四自”班组模式在煤炭企业中的探索与应用",
        "大区队机构改革在生产组织中的探索与实践",
        "发挥“六个引领作用”保障企业转型跨越发展",
        "煤炭企业轮值班组长的探索与践",
        "煤炭企业强化企业管理运行机制的探索与实践",
        "以提高资源保障能力为核心的“3331”生产组织模式研究与实践",
        "安全质量标准化在本质安全矿井建设中的作用"
      ]
    };
  }
};
</script>
<style lang="less" scoped>
#ResultNav {
  .list1 {
    border-left: 1px solid #d5d5d5;
    min-height: 8.45rem;
    padding-left: 0.31rem;
    font-weight: bold;
    ul {
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      margin-bottom: 0.6rem;
      li {
        width: 33%;
        font-size: 0.16rem;
        color: #222020;
        padding: 0.2rem 0.2rem 0.2rem 0;
        div {
          height: 0.8rem;
          line-height: 0.8rem;
          background: url(../assets/Conversion/bgG.png) no-repeat;
          background-size: 100% 100%;
          border-radius: 0.04rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 0.35rem;
        }
        div:hover {
          background: url(../assets/Conversion/bgB.png) no-repeat;
          background-size: 100% 100%;
          color: #fff;
          cursor: pointer;
        }
      }
      li.bb {
        border-bottom: 2px dashed #aaa;
      }
    }
  }
}
</style>